import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var MedicalCross = function MedicalCross(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M15 4.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C14.2401 3 13.9601 3 13.4 3h-2.8c-.5601 0-.84 0-1.054.109a1 1 0 0 0-.437.437C9 3.76 9 4.04 9 4.6v2.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C8.24 9 7.96 9 7.4 9H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 9.76 3 10.04 3 10.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C3.76 15 4.04 15 4.6 15h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C9 15.7599 9 16.0399 9 16.6v2.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437C9.76 21 10.04 21 10.6 21h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C15 20.2401 15 19.9601 15 19.4v-2.8c0-.5601 0-.8401.109-1.054a1 1 0 0 1 .437-.437C15.7599 15 16.0399 15 16.6 15h2.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437C21 14.2401 21 13.9601 21 13.4v-2.8c0-.5601 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.2401 9 19.9601 9 19.4 9h-2.8c-.5601 0-.8401 0-1.054-.109a1 1 0 0 1-.437-.437C15 8.24 15 7.96 15 7.4z"
    })
  }));
};
export default MedicalCross;